import PropTypes from "prop-types";
import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import i18n from "../../i18n";

const AddToCartConfirmation = ({ isOpen, productName, boxes, onClose, onContinue }) => {
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  const goToCart = () => {
    onClose();
    startTransition(() => {
      navigate(process.env.PUBLIC_URL + "/cart");
    });
  };

  return (
    <div className="aa-add-cart-overlay" role="presentation" onClick={onClose}>
      <div
        className="aa-add-cart-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="add-to-cart-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="aa-add-cart-close"
          aria-label={i18n.t("close")}
          onClick={onClose}
        />
        <div className="aa-add-cart-status" aria-hidden>
          <span className="aa-add-cart-checkmark" />
        </div>
        <h4 id="add-to-cart-title">
          {i18n.t("add_to_cart_success_title")}
        </h4>
        <p className="aa-add-cart-copy">
          {i18n.t("add_to_cart_success_body", { name: productName, boxes })}
        </p>
        <div className="aa-add-cart-actions">
          <button
            type="button"
            className="aa-add-cart-btn aa-add-cart-btn--primary"
            onClick={goToCart}
          >
            {i18n.t("view_cart")}
          </button>
          <button
            type="button"
            className="aa-add-cart-btn aa-add-cart-btn--secondary"
            onClick={onContinue || onClose}
          >
            {i18n.t("continue_shopping")}
          </button>
        </div>
      </div>
    </div>
  );
};

AddToCartConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  productName: PropTypes.string,
  boxes: PropTypes.number,
  onClose: PropTypes.func,
  onContinue: PropTypes.func
};

export default AddToCartConfirmation;
